import React, { useEffect, useState } from 'react'
import { Grid, TextField, Button } from '@mui/material'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import ComboBox from './ComboBox'

import { styled } from '@mui/material/styles'
import { makeGetRequest } from 'utils/api'

const Input = styled('input')({
  display: 'none',
})
const AddAccounts = ({ handleChange, handleAutocomplete, handleFileUpload, state }) => {
  const [tmpBank, setTempBank] = useState([])
  const [tmpAccType, setTmpAccType] = useState([])

  useEffect(() => {
    fetchBankData()
    fetchAccType()
  }, [])
  const Account_Types = [
    { id: 1, label: 'Open banking', value: 1 },
    { id: 2, label: 'Via CSV', value: 2 },
    { id: 3, label: 'Manuel', value: 3 },
  ]
  const fetchBankData = async () => {
    const { data, status } = await makeGetRequest('/api/Finance/Banks/', {}, true)
    const filterBankData = []
    data.map((v) => {
      filterBankData.push({ label: v.Nom + ' - ' + v.Ville, value: v.id })
      return ''
    })
    setTempBank([...filterBankData])
  }
  const fetchAccType = async () => {
    const filterAccType = []
    const { data } = await makeGetRequest('/api/Finance/AccounType/', {}, true)
    data.map((v) => {
      filterAccType.push({ label: v.TypeCompte, value: v.id })
      return ''
    })
    setTmpAccType([...filterAccType])
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} align="center">
          <ComboBox
            handleAutoComplete={handleAutocomplete}
            label="Type de création"
            data={Account_Types}
            name="acType"
          />
        </Grid>
        {state.acType === 2 && (
          <>
            <Grid item xs={12} align="center">
              <ComboBox
                handleAutoComplete={handleAutocomplete}
                label="Etablissement Financier"
                data={tmpBank}
                name="bankData"
              />
            </Grid>

            <Grid item xs={12} align="center">
              <ComboBox
                handleAutoComplete={handleAutocomplete}
                data={tmpAccType}
                name="newAccType"
                label="Type De Compte"
              />
            </Grid>
            <Grid item xs={12} md={12} align="center">
              <TextField
                id="outlined-basic"
                label="IBAN"
                name="IBAN"
                fullWidth
                onChange={handleChange}
                variant="outlined"
                size="small"
                placeholder="Type here.."
              />
            </Grid>
            <Grid item xs={6} align="center">
              <label htmlFor="contained-button-file1">
                <Input
                  accept="/*"
                  id="contained-button-file1"
                  onChange={handleFileUpload}
                  type="file"
                  name="csv1"
                />
                <Button variant="outlined" component="span" startIcon={<FileUploadIcon />}>
                  Upload CSV1
                </Button>
              </label>
              <a href="/csv1.csv">Template CSV1</a>
            </Grid>
            <Grid item xs={6} align="center">
              <label htmlFor="contained-button-file2">
                <Input
                  accept="/*"
                  name="csv2"
                  id="contained-button-file2"
                  onChange={handleFileUpload}
                  type="file"
                />
                <Button variant="outlined" component="span" startIcon={<FileUploadIcon />}>
                  Upload CSV2
                </Button>
              </label>
              <a href="/csv2.csv">Template CSV2</a>
            </Grid>
          </>
        )}
        {state.acType === 3 && (
          <>
            <Grid item xs={12} align="center">
              <ComboBox
                handleAutoComplete={handleAutocomplete}
                label="Etablissement Financier"
                data={tmpBank}
                name="bankData"
              />
            </Grid>

            <Grid item xs={12} align="center">
              <ComboBox
                handleAutoComplete={handleAutocomplete}
                data={tmpAccType}
                name="newAccType"
                label="Type De Compte"
              />
            </Grid>
            <Grid item xs={12} md={12} align="center">
              <TextField
                id="outlined-basic"
                label="IBAN"
                name="IBAN"
                fullWidth
                onChange={handleChange}
                variant="outlined"
                size="small"
                placeholder="Type here.."
              />
            </Grid>
            <Grid item xs={12} md={12} align="center">
              <TextField
                id="outlined-basic"
                label="N de compte"
                name="compte"
                fullWidth
                onChange={handleChange}
                variant="outlined"
                size="small"
                placeholder="Type here.."
              />
            </Grid>
            <Grid item xs={12} md={12} align="center">
              <TextField
                id="outlined-basic"
                label="Titulaire"
                name="titulaire"
                fullWidth
                onChange={handleChange}
                variant="outlined"
                size="small"
                placeholder="Type here.."
              />
            </Grid>
            <Grid item xs={12} md={12} align="center">
              <TextField
                id="outlined-basic"
                label="Devise"
                name="devise"
                fullWidth
                onChange={handleChange}
                variant="outlined"
                size="small"
                placeholder="Type here.."
              />
            </Grid>
            <Grid item xs={12} md={12} align="center">
              <TextField
                id="outlined-basic"
                label="Date d'ouverture"
                name="date"
                type="date"
                fullWidth
                onChange={handleChange}
                variant="outlined"
                size="small"
                placeholder="Type here.."
              />
            </Grid>
            <Grid item xs={12} md={12} align="center">
              <TextField
                id="outlined-basic"
                label="N Client"
                name="client"
                fullWidth
                onChange={handleChange}
                variant="outlined"
                size="small"
                placeholder="Type here.."
              />
            </Grid>
            <Grid item xs={12} md={12} align="center">
              <TextField
                id="outlined-basic"
                label="Cle RIB"
                name="rib"
                type="number"
                fullWidth
                onChange={handleChange}
                variant="outlined"
                size="small"
                placeholder="Type here.."
              />
            </Grid>
            <Grid item xs={12} md={12} align="center">
              <TextField
                id="outlined-basic"
                label="Nom"
                name="nom"
                fullWidth
                onChange={handleChange}
                variant="outlined"
                size="small"
                placeholder="Type here.."
              />
            </Grid>
          </>
        )}
      </Grid>
    </>
  )
}

export default AddAccounts
